import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { patchFinanzasNd } from "./ApiServices";
import ExpedienteArchivos from "./ExpedienteArchivos";
import {
  EMITE_ND_PROVEEDOR,
  TIPOS_ARCHIVO_RECHAZO,
} from "./chequesRechazos.constants";

export default function ModalFinanzasNd({ open, onClose, rechazo, onOk }) {
  const [via, setVia] = useState(EMITE_ND_PROVEEDOR.SI);
  const [confirmadoSisven, setConfirmadoSisven] = useState(false);
  const [nroRef, setNroRef] = useState("");
  const [obs, setObs] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setVia(EMITE_ND_PROVEEDOR.SI);
    setConfirmadoSisven(false);
    setNroRef("");
    setObs("");
    setError("");
  }, [open, rechazo]);

  const idRechazo = rechazo?.id ?? rechazo?.id_rechazo;

  const guardar = async () => {
    if (!idRechazo) return;
    if (!confirmadoSisven) {
      setError("Confirmá que el comprobante quedó cargado en Sisven.");
      return;
    }
    if (!nroRef.trim()) {
      setError("Indicá el nro. de referencia del comprobante.");
      return;
    }
    setGuardando(true);
    setError("");
    try {
      const ref = nroRef.trim();
      const body = {
        emite_nd_proveedor: via,
        sisven_confirmado: true,
        obs: obs.trim() || undefined,
      };
      if (via === EMITE_ND_PROVEEDOR.SI) {
        body.nro_nd_proveedor_ref = ref;
        if (/^\d+$/.test(ref)) body.id_comprobante_nd_proveedor = Number(ref);
      } else {
        body.nro_nd_interna_ref = ref;
      }
      await patchFinanzasNd(idRechazo, body);
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al confirmar la ND");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={guardando ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Finanzas — nota de débito</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Alert severity="info">
            Sisven queda fuera de la plataforma: cargá el comprobante ahí y
            confirmá acá con referencia y adjunto escaneado.
          </Alert>
          <TextField
            select
            size="small"
            fullWidth
            required
            label="Vía de ND"
            value={via}
            onChange={(e) => setVia(e.target.value)}
            disabled={guardando}
          >
            <MenuItem value={EMITE_ND_PROVEEDOR.SI}>
              El proveedor emitió ND — Finanzas carga el comprobante en Sisven
            </MenuItem>
            <MenuItem value={EMITE_ND_PROVEEDOR.NO}>
              Sin comprobante del proveedor — ND interna (jefe de sector)
            </MenuItem>
          </TextField>
          <FormControlLabel
            control={
              <Checkbox
                checked={confirmadoSisven}
                onChange={(e) => setConfirmadoSisven(e.target.checked)}
                disabled={guardando}
              />
            }
            label="Confirmé la carga en Sisven (paso manual)"
          />
          <TextField
            size="small"
            fullWidth
            required
            label={
              via === EMITE_ND_PROVEEDOR.SI
                ? "Nro. ND proveedor / id comprobante"
                : "Nro. ND interna"
            }
            value={nroRef}
            onChange={(e) => setNroRef(e.target.value)}
            disabled={guardando}
            helperText={
              via === EMITE_ND_PROVEEDOR.SI
                ? "Indicá el nro. de ND del proveedor o el id de comprobante"
                : "Indicá el nro. de la ND interna"
            }
          />
          <TextField
            size="small"
            fullWidth
            multiline
            minRows={2}
            label="Observaciones (opcional)"
            value={obs}
            onChange={(e) => setObs(e.target.value)}
            disabled={guardando}
          />
          <ExpedienteArchivos
            idRechazo={idRechazo}
            tipoDefault={
              via === EMITE_ND_PROVEEDOR.SI
                ? TIPOS_ARCHIVO_RECHAZO.ND_PROVEEDOR
                : TIPOS_ARCHIVO_RECHAZO.ND_INTERNA
            }
            compact
          />
          <Typography variant="caption" color="text.secondary">
            Cheque N° {rechazo?.nro_cheque || rechazo?.cheque?.nro_cheque || "—"}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={guardando}
          startIcon={guardando ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Confirmar y pasar a Pagos
        </Button>
      </DialogActions>
    </Dialog>
  );
}
